<div class="flex">
  <lib-itoaster />
  <div class="flex h-screen flex-1 flex-col overflow-auto">
    @if (isTest || isAdminLogin()) {
      <div class="flex w-full items-center justify-between bg-orange-600 px-4 py-1.5 text-white">
        <div>
          @if (isTest) {
            <span class="font-semibold">Demo environment</span>
          }
          @if (isAdminLogin()) {
            <span> • Admin Board</span>
          }
        </div>
        <IButton label="Debug Info" color="white" (onClick)="printDebugInfo()" size="sm" />
      </div>
    }
    @if (globalWarning$ | async) {
      <div class="border-sha w-full rounded-sm bg-red-100 px-4 py-1 text-red-700">
        {{ globalWarning$ | async }}
      </div>
    }
    <header class="sticky top-0 z-[50] flex w-full flex-col bg-white py-2">
      <div class="flex min-w-0 flex-1 items-center justify-between px-6" *transloco="let t">
        <div class="flex items-center gap-4">
          <a class="block w-[70px]" routerLink="/dashboard360" queryParamsHandling="merge">
            <logo></logo>
          </a>
          <ITabs [tabs]="tabs" [activeTab]="activeTab()" />
        </div>

        <IDropdown [items]="[settingsMenuItems]" placement="bottom-end">
          <IButton [icon]="ICON_SETTINGS" variant="ghost" color="gray" />
        </IDropdown>
      </div>
    </header>
    <div class="flex-1 p-4">
      <page-layout>
        <router-outlet />
      </page-layout>
    </div>
  </div>
</div>
